// Nome/sottotitolo/descrizione pubblici delle 3 linee prodotto, gestibili da
// Admin → Aspetto → Linee prodotto. Gli id interni start/power/elite restano
// sempre fissi (li usano prodotti, sconti, kit e i link del menu) — qui si
// legge solo il TESTO visibile, con fallback ai valori di default.
const FALLBACK = {
  start: {
    name: "MUSCLE",
    subtitle: "Benessere & Fondamenta",
    description: "La base solida del tuo percorso. Vitamine, minerali e nutrienti essenziali per attivare ogni giorno la tua energia naturale.",
  },
  power: {
    name: "PERFORMANCE",
    subtitle: "Muscolo & Crescita",
    description: "Spinta, recupero e costruzione. Le formule che alimentano l'allenamento e accelerano la tua trasformazione fisica.",
  },
  elite: {
    name: "WELLNESS",
    subtitle: "Performance Professionali",
    description: "Il vertice della nutrizione sportiva. Formulazioni di precisione per chi non accetta compromessi.",
  },
};

export const getTierNames = (settings) => {
  const t = settings?.tiers || {};
  const build = (id) => ({
    name: t[`${id}_name`] || FALLBACK[id].name,
    subtitle: t[`${id}_subtitle`] || FALLBACK[id].subtitle,
    description: t[`${id}_description`] || FALLBACK[id].description,
  });
  return { start: build("start"), power: build("power"), elite: build("elite") };
};
